export type Style = 'AUTO' | 'DESIGN' | 'REALISTIC' | 'GENERAL' | 'RENDER_3D' | 'ANIME';

export type AspectRatio = 
  | 'ASPECT_1_1' 
  | 'ASPECT_16_9' 
  | 'ASPECT_9_16' 
  | 'ASPECT_4_3' 
  | 'ASPECT_3_4';

export interface IdeogramPrompt {
  id?: string;
  style: Style;
  aspectRatio: AspectRatio;
  prompt: string;
  imageUrl: string;
  createdAt: string;
  status?: 'generating' | 'completed';
  isRemix?: boolean;
  sourceImageUrl?: string;
}

export const STYLES: Style[] = ['AUTO', 'DESIGN', 'REALISTIC', 'GENERAL', 'RENDER_3D', 'ANIME'];

export const ASPECT_RATIOS: AspectRatio[] = [
  'ASPECT_1_1',
  'ASPECT_16_9',
  'ASPECT_9_16',
  'ASPECT_4_3',
  'ASPECT_3_4'
];

export type PromptStyle = 'Product Development' | 'Fashion Design' | 'Graphic Design';

export const PROMPT_STYLES: PromptStyle[] = ['Product Development', 'Fashion Design', 'Graphic Design'];

export interface GeneratePromptsRequest {
  seedPrompt: string;
  promptStyle: PromptStyle;
  numberOfPrompts: number;
}

export interface GeneratePromptsResponse {
  prompts: string[];
}
